import { render, staticRenderFns } from "./AdminIndServiceLog.vue?vue&type=template&id=f6354d1c"
import script from "./AdminIndServiceLog.vue?vue&type=script&lang=js"
export * from "./AdminIndServiceLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports